/*
 * @Author: pangXf
 * 忘记密码
 */
import { observable, action, runInAction } from "mobx";
import { StepBaseProps, Dialog } from '@weapp/ui';
import { getLabel } from '@weapp/utils';
import * as ForgetAPI from '../../../api/pc/forgetPassword';
import {
  specialRegex,
  setTokenStorage,
  getTokenStorage,
  getSecurityStorage,
  setSecurityStorage,
  toCustomloginPage,
  setAccountStorage, mobileLocalReg, mobileReg
} from '../../../utils';

const { message } = Dialog;
export class FindPasswordStore {
  // 当前step
  @observable stepsActive: number = 0;
  // steps数据
  @observable stepsData: Array<StepBaseProps> = [];
  // 账户校验
  @observable accountCheck: any = null;
  // 提交验证码校验
  @observable sendCheck: any = null;
  // 密保启用状态
  @observable secrecyStatus: any = null; // D 关闭  E 启用

  init = () => {
    this.getSteps();
  }
  /**
   * 步骤
   */
  @action
  getSteps = () => {
    this.stepsData = [
      { title: getLabel('125614', '输入账号') },
      { title: getLabel('93554', '找回密码的方式') },
      { title: getLabel('93529', '找回密码') }
    ]
  }

  /**
    * 更新steps组件状态
    */
  @action
  updateStepsActive = (v: number) => {
    this.stepsActive = v
  }
  @action
  setValue = <T extends keyof FindPasswordStore>(key: T, value: this[T]) => {
    this[key] = value;
  }
  /**
   * 校验账号合法性
   * @param account
   */
  @action
  validateAccount = (account: string, methods: any, areacode?: string) => {
    return new Promise((resolve, reject) => {
      if (!account) {
        this.accountCheck = {
          type: 'error',
          content: getLabel('93481', '账号不能为空'),
          checked: true
        };
        return reject(this.accountCheck)
      }
      let accountChecked = true;
      const emailReg = /^([-_A-Za-z0-9.]+)@([_A-Za-z0-9-]+\.)+[A-Za-z0-9]{2,3}$/;
      let checkEmail = emailReg.test(account);
      let errorMessage = getLabel('93556', '格式不正确！请重新输入');

      // 只检查邮箱
      if (methods === '0') {
        accountChecked = checkEmail;
        errorMessage = getLabel('93383', '邮箱格式不正确')
      }
      if (methods === '1') {
        if (areacode === '+86') {//国内电话号校验
          accountChecked = mobileLocalReg.test(account);
        } else {//国外电话号校验
          accountChecked = mobileReg.test(account);
        }
        errorMessage = getLabel('179915', "请填写格式正确的手机号")
      }
      if (!accountChecked) {
        this.accountCheck = {
          type: 'error',
          content: errorMessage,
          checked: true
        };
        return reject(this.accountCheck)
      }
      ForgetAPI.checkAccount({ account, areacode }).then((result: any) => {
        runInAction(() => {
          if (!result.data) {
            this.accountCheck = {
              type: 'error',
              content: getLabel('178406', '账号不存在，请您重新输入'),
              checked: true
            }
            return reject(result)
          }
          // 校验成功保存账号到本地 用于刷新
          localStorage.setItem('e_forgetPwd_account', account)
          if (areacode) {
            localStorage.setItem('e_forgetPwd_areaCode', areacode)
          }
          this.accountCheck = {
            checked: true
          }
          resolve(result)
        })
      }).catch((error: any) => {
        reject(error)
      })
    })
  }
  /**
   * 发送手机验证码
   * @param account
   */
  @action
  sendMobileCode = (account: string, areaCode?: string, callback?: Function) => {
    ForgetAPI.sendMobileCode({ account, areaCode }).then((result: any) => {
      runInAction(() => {
        if (result.data) {
          if (result.data.errorMsg) {
            return this.sendCheck = {
              type: 'error',
              content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
            }
          } else {
            callback?.();
          }
          this.sendCheck = null
          setTokenStorage(result.data)
        }
      })
    }).catch((error: any) => {
      console.log(error)
    })
  }
  /**
   * 发送邮箱验证码
   * @param account
   */
  @action
  sendEmailCode = (account: string) => {
    return new Promise((resolve, reject) => {
      ForgetAPI.sendEmailCode({ account }).then((result: any) => {
        if (result.data) {
          if (result.data.errorMsg) {
            reject(result)
            return message({
              type: 'error',
              content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
            })
          }
          setSecurityStorage('e_forgetPwd_wayPage_sendEmail', account)
          resolve(result)
        }
        reject(result)
      }).catch((error: any) => {
        console.log(error)
      })
    })
  }
  /**
   * 获取邮箱修改密码token
   * @param key
   */
  @action
  getTokenByEmail = (key: string) => {
    return new Promise((resolve, reject) => {
      ForgetAPI.getTokenByEmail({ key }).then((result: any) => {
        runInAction(() => {
          if (result.data) {
            if (result.data.errorMsg) {
              //找回密码key已经被使用
              // message({
              //   type: 'error',
              //   content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
              // })
              reject(result)
              return;
            }
            const { user, token, customTenantKey } = result.data;
            if (customTenantKey) {
              sessionStorage.setItem('email_psw_customTenantKey', customTenantKey);
            }
            setTokenStorage(token)
            localStorage.setItem('e_forgetPwd_account', user.email || user.account);
            resolve(user.email || user.account)
          }
        })
      }).catch((error: any) => {
        console.log(error)
      })
    })
  }
  /**
   * 确认修改
   * @param account
   * @param code
   * @param password
   * @param passwordConfirm
   */
  @action
  confirmChangePwd = (account: string, password: string, passwordConfirm: string, code: string) => {
    return new Promise((resolve, reject) => {
      let payload: any = { password, passwordCheck: passwordConfirm, code, userIdToken: getTokenStorage() }
      let isMail = account.indexOf('@') !== -1
      let requestWay = isMail ? ForgetAPI.changeByEmail : ForgetAPI.changeByMobile
      requestWay(payload).then((result: any) => {
        runInAction(() => {
          if (result.data?.errorMsg) {
            message({
              type: 'error',
              content: result.data.errorMsg.alreadyTranslate ? result.data.errorMsg.msg : getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
            })
            return reject(result)
          }
          if (!result.status) {
            message({
              type: 'error',
              content: result.msg
            })
            return reject(result)
          }
          resolve(result)
        })
      }).catch((error: any) => {
        reject(error)
      })
    })
  }
  /**
   * 密保验证后确认修改密码
   * @param password
   * @param passwordConfirm
   */
  @action
  confirmChangePwdBySecrecy = (password: string, passwordConfirm: string) => {
    return new Promise((resolve, reject) => {
      const securityToken = getSecurityStorage('e_security_token')
      let payload: any = { password, passwordCheck: passwordConfirm, userIdToken: securityToken }
      ForgetAPI.changeBySecrecy(payload).then((result: any) => {
        runInAction(() => {
          if (result.data) {
            if (result.data.errorMsg) return this.handleI18NFailTip(result, reject);
            if (result.code === 200) return resolve(result)
          }
          if (result.code === 40014) {
            // 密保验证过期 重新回到验证密保页面
            message({ type: 'error', content: result.msg })
            return reject('needSecurity')
          }
          reject(result)
        })
      }).catch((error: any) => {
        reject(error)
      })
    })
  }
  handleI18NFailTip = (response: any, reject: any) => {
    let info = response.data && response.data.errorMsg || {}
    message({
      type: 'error',
      content: getLabel(info.i18nId, info.msg)
    })
    reject(info)
  }

  /**
   * 查询用户是否开启密保找回
   * @param account
   */
  @action
  qrySecrecyStatus = (account: string) => {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await ForgetAPI.querySecrecyStatus(account)
        if (response.data && response.data.errorMsg) {
          return this.handleI18NFailTip(response, reject)
        }
        let { result } = response.data || {}
        runInAction(() => {
          this.secrecyStatus = result || 'D'
        })
        resolve(result || 'D')
      } catch (e) { reject(e) }
    })
  }

  @action
  qryUserSecrecy = (account: string) => {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await ForgetAPI.qryUserSecrecy(account)
        if (response.data && response.data.errorMsg) {
          return this.handleI18NFailTip(response, reject)
        }
        resolve(response.data)
      } catch (e) { reject(e) }
    })
  }

  @action
  validSecrecy = (account: string, data: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        let payload = {
          params: [data]
        }
        let response = await ForgetAPI.validSecrecy(account, payload)
        if (response.code !== 200) {
          if (response.data?.errorMsg) {
            message({
              type: 'error',
              content: response.data?.errorMsg ?
                getLabel(response.data?.errorMsg.i18nId, response.data?.errorMsg.msg) :
                response.msg
            })
          }
          return reject(response)
        }
        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    })
  }
}
const instance = new FindPasswordStore();

export default instance;
export type FindPasswordStoreType = Pick<FindPasswordStore, keyof FindPasswordStore>;
